var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUbipin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70.459,
    height: 90.083,
    viewBox: "0 0 70.459 90.083",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-32 -93)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64.515,
    height: 90.083,
    transform: "translate(32 93)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32 93)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.576,16.108A35.229,35.229,0,0,0,19.754,65.93h0L44.665,90.841,69.576,65.931A35.23,35.23,0,0,0,69.576,16.108ZM61.856,46.96c0,13.073-7.009,17.067-17.191,17.043-10.182.024-17.191-3.97-17.191-17.043V23.84H37.847v25.2q0,3.555,2.075,5.186a7.716,7.716,0,0,0,9.485,0q2.077-1.628,2.075-5.186V28.88a4.983,4.983,0,0,1,1.408-3.558,4.79,4.79,0,0,1,3.631-1.482h5.334Z",
    transform: "translate(-9.435 -5.79)",
    fill: "#00b2ff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUbipin);
export default __webpack_public_path__ + "static/media/ubipin.18c38ae522f9a7b22f61b156dba2f555.svg";
export { ForwardRef as ReactComponent };